export const SECONDARY_CONTACT_OPTIONS = {
  NOTES: "Patient.SecondaryContact.Notes",
  EMAIL_ADDRESS: "Patient.SecondaryContact.EmailAddress",
  PHONE: "Patient.SecondaryContact.Phone",
  TYPE_OF_PHONE_NUMBER: "Patient.SecondaryContact.TypeOfPhoneNumber",
  FULL_ADDRESS: "Patient.SecondaryContact.FullAddress",
  STREET_ADDRESS_LINE1: "Patient.SecondaryContact.StreetAddressLine1",
  STREET_ADDRESS_LINE2: "Patient.SecondaryContact.StreetAddressLine2",
  CITY: "Patient.SecondaryContact.City",
  STATE: "Patient.SecondaryContact.State",
  ZIP_CODE: "Patient.SecondaryContact.ZIPCode",
};
